import { Text } from "@mantine/core";
import { IconTemperature } from "@tabler/icons-react";
import InfoItem from "components/InfoItem";
import { isValidTemperature } from "utils/temperature";

interface ChatContextTemperatureItemProps {
  temperatureMin?: number | null;
  temperatureMax?: number | null;
}

const formatTemperature = (value?: number | null): string =>
  typeof value === "number" ? (value >= 0 ? `+${value}` : `${value}`) : "-";

const ChatContextTemperatureItem: React.FC<ChatContextTemperatureItemProps> = ({
  temperatureMin,
  temperatureMax,
}) => (
  <InfoItem
    gap={8}
    visible={
      isValidTemperature(temperatureMin) || isValidTemperature(temperatureMax)
    }
    icon={<IconTemperature className="w-6 h-6" />}
    label={
      <Text fz={14}>
        {formatTemperature(temperatureMin)}/{formatTemperature(temperatureMax)}{" "}
        °C
      </Text>
    }
  />
);

export default ChatContextTemperatureItem;
